import classNames from 'classnames'
import { ContextMenu } from '@winnin/winnin_ui.components.context-menu'
import { Icon } from '@winnin/winnin_ui.components.icon'

import type { IDropdownLabel } from './types'
import './styles.scss'

export default function DropdownWithLabel({ label, options, position, className }: IDropdownLabel) {
  const selected = options.find(option => Boolean(option.isSelected)) ?? options[0]
  return (
    <div className={classNames(['DropdownWithLabel-wrapper', className])}>
      <ContextMenu menuItems={options} position={position}>
        <div className="DropdownWithLabel-button">
          <label htmlFor="" className="DropdownWithLabel-label">
            {label}
          </label>
          <span className="DropdownWithLabel-selected">{selected.label}</span>
          <Icon icon="arrowDown" width={18} height={18} fill="var(--color_neutral_800)" />
        </div>
      </ContextMenu>
    </div>
  )
}
